import { Alert, Button, IconButton, InputAdornment, TextField, Typography } from "@mui/material"
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";

export default function SavePasswordDialogComponent ({createUserData}) {

    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    const handleCopyToClipboard = (e, pass) => {
        navigator.clipboard.writeText(pass);

        enqueueSnackbar("Copied", {
            variant: "success",
            autoHideDuration: 3000
        });
    }

    console.log('asdfasdfasdfasdfsda', createUserData)

    return(
        <>
            <Alert severity="info">Please make sure to save your password before closing.</Alert>

            <TextField
                fullWidth
                value={createUserData?.email}
                variant="outlined"
                autoComplete="off"
                sx={{ "& .MuiInputBase-root": { height: 38, borderRadius: 1, backgroundColor:'white', mt: 2 } }}
                placeholder="New password"
                disabled
                slotProps={{
                    input: {
                        startAdornment: <InputAdornment position="start">Email:</InputAdornment>,
                    },
                }}
            />

            <TextField
                fullWidth
                value={createUserData?.password}
                variant="outlined"
                autoComplete="off"
                sx={{ "& .MuiInputBase-root": { height: 38, borderRadius: 1, backgroundColor:'white', mt: 2 } }}
                placeholder="New password"
                disabled
                slotProps={{
                    input: {
                    startAdornment: <InputAdornment position="start">Password:</InputAdornment>,
                    endAdornment: <IconButton className="card-copy-sub-key" sx={{ textTransform: "none", fontSize: 10 }}
                    onClick={(e) => handleCopyToClipboard(e, createUserData?.password)}
                >
                    <ContentCopyIcon sx={{ width: 18, height: 18, color: "#0178f2" }} />
                </IconButton>
                    },
                }}
            />
            <Button onClick={() => navigate(-1)} fullWidth variant='contained' sx={{textAlign:'center', mt: 4}}>Close</Button>
        </>
    )
}